/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EClassRoomUserType } from "../types/EClassRoomUserType.ts";

/**
 * @description 1 = Monitor | 2 = Instructor | 3 = Student | 4 = Viewer |
 */
export const eClassRoomUserTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Monitor | 2 = Instructor | 3 = Student | 4 = Viewer | ",
  ) as unknown as ToZod<EClassRoomUserType>;
